import { Methods } from '@api/shop/get';
import { Request } from '../../request';
export default async (query:Methods["get"]["query"]) => Request( client => client.shop.get.$get({query}) )
